import type { PropsWithChildren, ReactNode } from 'react'

import { Tooltip } from '../Tooltip'

type Props = {
  info?: string
  meta?: string
  disabled?: boolean
}

/*
 * Used for providing some additional information as an info bubble
 */
export default function InfoGroup({ info, meta, disabled, children }: Readonly<PropsWithChildren<Props>>): ReactNode {
  if (!info) return children

  return (
    <div>
      {children}
      <Tooltip content={info} disabled={disabled} />
      <span className="ep-form-row-label-text ep-form-row-label-counter">{meta}</span>
    </div>
  )
}
